import React, { useEffect, useRef, useState } from 'react';
import Spinner from '../shared/Spinner';
import LoadFailure from '../shared/LoadFailure';

export default function QrModal({ title, qr, onClose }) {
    const [loaded, setLoaded] = useState(false);
    const [failed, setFailed] = useState(false);
    const [retryCount, setRetryCount] = useState(0);
    const imageRef = useRef(null);
    // A changed query string forces the browser to refetch an image it cached as failed.
    const imageSrc = retryCount === 0 ? qr : qr + (qr.includes('?') ? '&' : '?') + `retry=${retryCount}`;
    const downloadHref = qr + (qr.includes('?') ? '&' : '?') + 'format=png&download=1';

    // A cached image can finish before React attaches onLoad, so read the
    // element's own state after every src change instead of trusting the event.
    useEffect(() => {
        setLoaded(false);
        setFailed(false);
        const image = imageRef.current;
        if (image && image.complete && image.naturalWidth > 0) {
            setLoaded(true);
        }
    }, [imageSrc]);

    return (
        <div role="dialog" aria-label={`${title} QR code`} className="modal d-block" tabIndex="-1">
            <div className="modal-dialog" role="document">
                <div className="modal-content">
                    <div className="modal-header">
                        <h4 className="modal-title">{title}</h4>
                    </div>
                    <div className="modal-body text-center">
                        <div className="demo-qr-frame">
                            <img
                                ref={imageRef}
                                src={imageSrc}
                                alt={`QR code for ${title}`}
                                className="demo-qr-frame-image"
                                style={failed ? { display: 'none' } : undefined}
                                onLoad={() => setLoaded(true)}
                                onError={() => {
                                    console.error('QrModal: failed to load the QR code image', imageSrc);
                                    setFailed(true);
                                    setLoaded(true);
                                }}
                            />
                            {failed &&
                                <div className="demo-qr-frame-loading">
                                    <LoadFailure message={__('Could not load the QR code.')} onRetry={() => setRetryCount((count) => count + 1)} />
                                </div>
                            }
                            {!loaded &&
                                <div className="demo-qr-frame-loading">
                                    <Spinner label={__('Loading QR code...')} />
                                </div>
                            }
                        </div>
                    </div>
                    <div className="modal-footer">
                        <a href={downloadHref} className="btn btn-primary">
                            {__('Download')}
                        </a>
                        <button type="button" className="btn btn-secondary" onClick={onClose}>
                            {__('Close')}
                        </button>
                    </div>
                </div>
            </div>
        </div>
    );
}
